// extracted by mini-css-extract-plugin
export var filterForm = "PostsModuleGridLayout-module--filterForm--2R1kC";